import { useState } from "react";
import { useDispatch } from "react-redux";
import { ticketUpdateCurrentMedicalStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";

export const useMedicalCondition=()=>{
    const dispatch = useDispatch();
    const [responses, setResponses] = useState<any>({
      isAmbulanceRequired: "Yes",
      isDoctorConsultationRequired: "Yes",
      isPatientConscious: "Yes",
      mobilityStatus: "",
    });
  const handleOptionChange = (name: string, value: string) => {
    setResponses((prevResponses: any) => {
      const updatedResponses = {
        ...prevResponses,
        [name]: value,
      };
      const dispatchPayload: any = { [name]: value };



      dispatch(ticketUpdateCurrentMedicalStatusSuccess(dispatchPayload));
      return updatedResponses;
    });
  }
    return {
        responses,handleOptionChange
    }

}